module.exports = __webpack_public_path__ + "img/title-bg.440c2ffb.png";